class DiamondSliders {
  constructor(el) {
    this.el = el;
    this.track = el.querySelector('.diamondslider__track');
    this.slides = Array.from(this.track.children);
    this.prevBtn = el.querySelector('.diamondslider__control.prev');
    this.nextBtn = el.querySelector('.diamondslider__control.next');
    this.currentIndex = 0;
    this.isTransitioning = false;

    this.init();

    this.prevBtn.addEventListener('click', () => this.move(-1));
    this.nextBtn.addEventListener('click', () => this.move(1));
    window.addEventListener('resize', () => this.handleResize());

    // Swipe support
    let startX = 0;
    let isDragging = false;
    
    this.track.addEventListener('touchstart', e => {
      startX = e.touches[0].clientX;
      isDragging = true;
    });
    
    this.track.addEventListener('touchmove', e => {
      if (!isDragging) return;
      const diff = e.touches[0].clientX - startX;
      if (Math.abs(diff) > 50) {
        this.move(diff < 0 ? 1 : -1);
        startX = e.touches[0].clientX;
      }
    });
    
    this.track.addEventListener('touchend', () => {
      isDragging = false;
    });
  }

  init() {
    this.updateVisibleSlides();
    
    // Clone slides for infinite loop
    const originalSlides = [...this.slides];
    
    // Add clones at the end
    originalSlides.forEach(slide => {
      const clone = slide.cloneNode(true);
      clone.classList.add('clone');
      this.track.appendChild(clone);
    });
    
    // Add clones at the beginning
    originalSlides.reverse().forEach(slide => {
      const clone = slide.cloneNode(true);
      clone.classList.add('clone');
      this.track.insertBefore(clone, this.track.firstChild);
    });
    
    // Update slides array to include clones
    this.allSlides = Array.from(this.track.children);
    
    // Start at the first original slide (after prepended clones)
    this.currentIndex = this.slides.length;
    this.updatePosition(false);
  }

  updateVisibleSlides() {
    const width = window.innerWidth;
    if (width <= 600) this.visible = 3;
    else if (width <= 768) this.visible = 3;
    else if (width <= 1024) this.visible = 6;
    else this.visible = 10;
  }

  handleResize() {
    this.updateVisibleSlides();
    this.updatePosition(false);
  }

  updatePosition(animate = true) {
    const slideWidth = this.allSlides[0].offsetWidth + 15;
    
    if (animate) {
      this.track.style.transition = 'transform 0.4s ease';
    } else {
      this.track.style.transition = 'none';
    }
    
    this.track.style.transform = `translateX(-${this.currentIndex * slideWidth}px)`;
  }

  move(direction) {
    if (this.isTransitioning) return;
    
    this.isTransitioning = true;
    this.currentIndex += direction;
    
    this.updatePosition(true);
    
    // Handle infinite loop
    setTimeout(() => {
      const totalOriginal = this.slides.length;
      
      // If we've moved past the end clones, jump to the start of original slides
      if (this.currentIndex >= totalOriginal * 2) {
        this.currentIndex = totalOriginal;
        this.updatePosition(false);
      }
      
      // If we've moved before the start clones, jump to the end of original slides
      if (this.currentIndex < totalOriginal) {
        this.currentIndex = totalOriginal * 2 - 1;
        this.updatePosition(false);
      }
      
      this.isTransitioning = false;
    }, 400);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.diamondslider').forEach(el => new DiamondSliders(el));
});